export const sortingGameData: any =
    [
        {
            id: 'plastic',
            img: 'item-plastic-bottle'
        },
        {
            id: 'glass',
            img: 'item-glass-jar'
        },
        {
            id: 'paper',
            img: 'item-paper'
        },
        {
            id: 'metal',
            img: 'item-tin-can'
        },
        {
            id: 'non-recyclable',
            img: 'item-bin-bag'
        }
    ];


// WEBPACK FOOTER //
// ./src/ts/data/SortingGameData.ts